'use client';
import React from 'react';
import dynamic from 'next/dynamic';

const OrgActivationsChart = dynamic(() => import('./OrgActivationsChart'), { ssr: false });
const SubscriptionDistributionChart = dynamic(() => import('./SubscriptionDistributionChart'), { ssr: false });

export default function PlatformChartsRow() {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-5 xl:grid-cols-5 2xl:grid-cols-5 gap-6">
      <div className="lg:col-span-3 bg-card border border-border rounded-xl p-5 card-hover">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-sm font-600 text-foreground">Organization Activations</h3>
            <p className="text-[12px] text-muted-foreground mt-0.5">New org activations over last 12 weeks</p>
          </div>
          <span className="badge-success text-[11px] font-500 px-2.5 py-1 rounded-full">+8 this month</span>
        </div>
        <OrgActivationsChart />
      </div>
      <div className="lg:col-span-2 bg-card border border-border rounded-xl p-5 card-hover">
        <div className="flex items-center justify-between mb-4">
          <div>
            <h3 className="text-sm font-600 text-foreground">Subscription Distribution</h3>
            <p className="text-[12px] text-muted-foreground mt-0.5">Active plans by tier</p>
          </div>
        </div>
        <SubscriptionDistributionChart />
      </div>
    </div>
  );
}